import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavController, LoadingController } from '@ionic/angular';
import { EventDetailsModel, EventProvider, EventTievts } from '../../providers/event/event';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { NavigationService } from 'src/providers/navigation/navigation.service';
import { LoaderProvider } from 'src/providers/loader/loader';
import { environment } from 'src/environments/environment';


@Component({
    selector: 'container-with-items',
    templateUrl: 'container-with-items.html',
    styleUrls:['./container-with-items.scss']
})
export class ContainersWithItemsComponent {
    @Input() type: string;
    @Input("index") containerIndex = null;
    @Input() container: ContainerWithItems; 
    @Output() expandContainer = new EventEmitter<ContainerWithItems>();
    spooortsDomain:string = environment.spooortsWebApp;

    constructor(
        public navCtrl: NavController,
        private translate: TranslateService,
        private router:Router,
        private loadingCtrl: LoadingController,
        private eventService: EventProvider,
        private navService:NavigationService,
        private loadingProv: LoaderProvider,
    ) { 
        console.log('container', this.container)
    }

    onExpandContainer(){
        this.expandContainer.emit(this.container);
    }

    getEventStatus(event: EventTievts) {
        if (typeof event === "undefined") return "";
        let status = event.eventStatus;
        if (status.toUpperCase().includes("CANCELLED")) return this.translate.instant('EVENT_CANCELLED');
        else if (status.toUpperCase().includes("NOT_CONFIRMED")) return this.translate.instant('NOT_CONFIRMED');
        else return "";
    }


    async openEventDetails(event) {
        console.log('openEventDetails')
        let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
        this.eventService.getEventId(event.eventName, event.ort, event.dateFormatted, event.cid).then(id => {
            if (id == -1) { loader.dismiss(); return; };

            this.eventService.getEventDetails(id).then((event: EventDetailsModel) => {
                if (event.name.length < 1) {
                    this.openEventDetails(event);
                    loader.dismiss();
                } else {
                    this.navCtrl.navigateForward('/tab1/event/details/tabs', {state:{event: event}})
                    .then(() => {
                        loader.dismiss()
                    });
                    // (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
                }
            });
        })
    }
}

export interface ContainerWithItems { 
    eventArea: string;
    eventType: string;
    items: any [];
    index?: number;
}